import { BehaviorSubject } from "rxjs"

// Generic types
export type IWsMessage = IWsDataMessage | IWsErrorMessage
export function isIWsMessage(message: any): message is IWsMessage {
  return isIWsDataMessage(message) || isIWsErrorMessage(message)
}
export interface IWsDataMessage {
  topic: string,
  data: any
}
export function isIWsDataMessage(message: any): message is IWsDataMessage {
  return message.hasOwnProperty("topic") && message.hasOwnProperty("data")
}
export interface IWsErrorMessage {
  topic: string,
  error: string
}
export function isIWsErrorMessage(message: any): message is IWsErrorMessage {
  return message.hasOwnProperty("topic") && message.hasOwnProperty("error")
}

export interface IWsSubscription {
  data: BehaviorSubject<any>
  subscribers: number
}

// Data types
export interface IDataTLEs {
  tles: Array<[string, string, string]>
  timestamp: number
}

export interface IDataISSNamedLocation {
  coordinates: [number, number],
  text: string,
  rawText: any,
  timestamp: Date
}
